/*
 * @Author: your name
 * @Date: 2022-01-12 10:20:26
 * @LastEditTime: 2022-01-12 10:27:10
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \wp-empowerment-tools-web\src\services\group.ts
 */
import { GROUP_DETAIL } from "../const"
import request from "../utils/request"
/**
 * @Description 分页查询群SOP任务执行详情
 * @author hz21087108
 * @date 2021-12-13
 * @param {any} params:any
 * @returns {Promise<any>}
 */
const fetchGroupSopTasks = (params: any) => {
  return request.post(GROUP_DETAIL.getGroupSopTasks, { data: params })
}

/**
 * @Description 侧边栏点击完成S群OP任务
 * @author hz21087108
 * @date 2021-12-13
 * @returns {Promise<any>}
 */
const completeGroupSopTask = (params: any) => {
  return request.post(GROUP_DETAIL.completeGroupSopTask, { params: params })
}

const getGroupInfo = (data: any) => {
  // GROUP_DETAIL
  return request.post(`${GROUP_DETAIL.getGroupInfo}`, { data })
}
const getGroupTag = (data: any) => {
  return request.post(`${GROUP_DETAIL.getTagData}`, { data })
}
///v1/customer/groupChatTag/getTag
const getGroupChatTag = (data: any) => {
  return request.post(`${GROUP_DETAIL.getGroupChatTag}`, { data })
}
///v1/customer/groupChatTag/markTag
const markGroupTag = (data: any) => {
  return request.post(`${GROUP_DETAIL.markGroupTag}`, { data })
}

const getStatisticsActive = (params: any) => {
  return request.get(`${GROUP_DETAIL.getStatisticsActive}`, { params })
}

const getStatisticsAge = (params: any) => {
  return request.get(`${GROUP_DETAIL.getStatisticsAge}`, { params })
}
const getStatisticsRegion = (params: any) => {
  return request.get(`${GROUP_DETAIL.getStatisticsRegion}`, { params })
}
const getStatisticsSex = (params: any) => {
  return request.get(`${GROUP_DETAIL.getStatisticsSex}`, { params })
}

//getGroupMemberPage
const getGroupMemberPage = (data: any) => {
  return request.post(`${GROUP_DETAIL.getGroupMemberPage}`, { data })
}

export {
  fetchGroupSopTasks,
  completeGroupSopTask,
  getGroupChatTag,
  getGroupInfo,
  getGroupTag,
  markGroupTag,
  getStatisticsActive,
  getStatisticsRegion,
  getStatisticsAge,
  getStatisticsSex,
  getGroupMemberPage,
}
